export default __webpack_public_path__ + "169c28186697417a79011226eb9d6aaa.png";